<template>
  <div>
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <!-- <el-form-item label="上传单位">
        <el-select
          size="small"
          v-model="form.value"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="评价模版名称">
        <el-input
          size="small"
          v-model="form.templateName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" size="small" @click="getEvaluateTemplateList"
          >查询</el-button
        >
        <el-button size="small" @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      :data="data"
      style="width: 100%; margin-top: 20px"
      @current-change="clickChange"
    >
      <el-table-column label width="35">
        <template slot-scope="scope">
          <el-radio :label="scope.row" v-model="tableRadio">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="templateName" label="评价模板名称">
      </el-table-column>
      <el-table-column prop="hasContent" label="是否需要评价内容">
        <template slot-scope="scope">
          {{ scope.row.hasContent === 1 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="deptName" label="上传单位"> </el-table-column>
      <el-table-column prop="creator" label="上传人"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link type="primary" @click="see(scope.row)">查看</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="se-flex-h-c se-m-t-20">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="currentPage"
        :page-size="form.pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 评价对话框 -->
    <el-dialog
      title="课程评价"
      :modal="false"
      :visible.sync="visible"
      width="28%"
    >
      <user-evaluate
        :satrInfo="satrInfo"
        ref="evaluate"
        justRead
      ></user-evaluate>
      <span slot="footer" class="se-flex jcc">
        <el-button type="danger" style="width: 117px" @click="visible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import userEvaluate from "../../course-info/components/userEvaluate.vue";
export default {
  components: {
    userEvaluate,
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 5,
        templateName: "",
        enabled: 1,
      },
      // options: [
      //   {
      //     label: '项目部',
      //     value: 1
      //   }
      // ],
      value: "",
      data: [],
      currentPage: 1,
      total: 0,
      tableRadio: "",
      loading: false,
      satrInfo: {},
      visible: false,
    };
  },

  created() {
    this.getEvaluateTemplateList();
  },

  methods: {
    // 分页回调
    currentChange(val) {
      this.form.pageNum = val;
      this.getEvaluateTemplateList();
    },

    async getEvaluateTemplateList() {
      this.loading = true;
      const res = await this.$http.get("/server/api/template/list", this.form);
      this.data = res.rows;
      this.total = res.total;
      this.loading = false;
    },

    async see(value) {
      const {
        data: { hasContent, hasStar, labels },
      } = await this.$http.get(`/server/api/template/${value.id}`);
      this.satrInfo = {
        hasContent,
        hasStar,
        trainCourseEvaTmplLabels: labels,
      };
      this.visible = true;
    },

    // 表格选择回调
    handleCurrentChange(e) {
      // console.log(e, "e");
    },

    clickChange(item) {
      this.tableRadio = item;
    },

    // 确认
    confirm() {
      this.$emit("sendData", this.tableRadio);
    },

    // 重置
    onReset() {
      this.form.templateName = "";
      this.getEvaluateTemplateList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
